/* eslint-disable */
import { useGlobalContext } from "../context";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ErrorBoundary from "./ErrorBoundary";
import React, { useState } from "react";

const ProductDataHeaderBox = () => {
  const { productData, imgIsUndefined, SetImgUndefined, onImgError } =
    useGlobalContext();
  const [imageSrc, setImageSrc] = useState('');
  const passResult = productData.PassResult;
  const src = passResult.PictureUrl.split("//")[1];
  const { t } = useTranslation();

  var manufacturingDate = productData.PassResult["DateManufacturing"];
  //var manufacturingDate = moment(str, "DD-MM-YYYY").format("MM/YYYY");
  const prodDate = manufacturingDate;

  useEffect(() => {
    const passResult = productData.PassResult;
    const src = passResult.PictureUrl.split("//")[1];
    const mainImageBase64 = passResult.PictureData;
    // pictureData is the leading field
    if (mainImageBase64) {
      const imageUrl = `data:image/jpeg;base64,${mainImageBase64}`;
      setImageSrc(imageUrl);
    } else if (src) {
      const imageUrl = `https://portal.wika.com/serial/resource/serial/${src}`;
      setImageSrc(imageUrl);
    }
  }, [productData]); 


  useEffect(() => {
    document.getElementById("typetextsecondline").innerHTML =
      passResult.TypeTextSecondLine;
    // set this so even if error occurs and image is missing, next image will load successfully
    SetImgUndefined(false);
  }, [passResult.TypeTextSecondLine]);

  if (imgIsUndefined) {
    return (
      <>
        <section className="wika-section">
          <ErrorBoundary>
            <Row>
              <ErrorBoundary>
                <Col sm={12} lg={8} md={6} className="wika-product-box">
                  <div className="wika-small-text">
                    {t("productdataHeader.type")} {passResult.TypeText}
                  </div>
                  <div id="typetextsecondline"> </div>
                  <hr />
                  <div className="wika-small-text">
                    {t("productdataHeader.serialNumber")}:{" "}
                  </div>
                  <div className="wika-fat-text code-block">{productData.PassResult["SerialNumber"]}</div>
                  <div className="wika-small-text">
                    {t("productdataHeader.itemNumber")}:{" "}
                  </div>
                  <div className="wika-fat-text">{productData.PassResult["ItemNumber"]}</div>

                  <div className="wika-small-text">
                    {t("tabProductPass.productionDate")}:{" "}
                  </div>
                  <div className="wika-fat-text">{prodDate}</div>
                </Col>
              </ErrorBoundary>
              <ErrorBoundary>
                <Col sm={12} lg={4} md={6} className="card">
                  <i className="fa-solid fa-camera-slash fa-10x"></i>

                  <div className="card-body">
                    <p className="card-text wika-pic-desc">
                      {passResult.PictureDesc}
                    </p>
                  </div>
                </Col>
              </ErrorBoundary>
            </Row>
          </ErrorBoundary>
        </section>
      </>
    );
  }

  return (
    <>
      <section className="wika-section">
        <ErrorBoundary>
          <Row>
            <ErrorBoundary>
              <Col sm={12} lg={8} md={6} className="wika-product-box">
                <div className="wika-small-text">
                  {t("productdataHeader.type")} {passResult.TypeText}
                </div>
                <div id="typetextsecondline"> </div>
                <hr />
                <div className="wika-small-text">
                  {t("productdataHeader.serialNumber")}:{" "}
                </div>
                <div className="wika-fat-text code-block">{productData.PassResult["SerialNumber"]}</div>
                <div className="wika-small-text">
                  {t("productdataHeader.itemNumber")}:{" "}
                </div>
                <div className="wika-fat-text code-block">{productData.PassResult["ItemNumber"]}</div>

                <div className="wika-small-text">
                  {t("tabProductPass.productionDate")}:{" "}
                </div>
                <div className="wika-fat-text code-block">{prodDate}</div>
              </Col>
            </ErrorBoundary>
            <ErrorBoundary>
              <Col sm={12} lg={4} md={6} className="wika-card">
              {imageSrc && 
                <img
                  src={imageSrc}
                  className="card-img-top wika-img-right-col"
                  alt={passResult.TypeText}
                  onError={onImgError}
                />
              }
                <div className="card-body">
                  <p className="card-text wika-pic-desc">
                    {passResult.PictureDesc}
                  </p>
                </div>
              </Col>
            </ErrorBoundary>
          </Row>
        </ErrorBoundary>
      </section>
    </>
  );
};

export default ProductDataHeaderBox;
